import { Component } from "react";
import { logErrorToFirebase } from "../firebase/firebaseAnalytics";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        logErrorToFirebase("react_error", error.toString(), {
            componentStack: errorInfo.componentStack,
        });
    }

    render() {
        return this.props.children;
    }
}

export default ErrorBoundary;
